import React, { ReactNode } from 'react';
import cx from 'classnames';

import { IconX } from '../icons';

interface Props<I> {
    content?: ReactNode;
    remove: RemoveToast;
    kind: ToastKind;
    RenderContent?: ToastRenderContent<I>;
    renderContentInput?: I;
}

/**
 * A toast that looks like a narrow banner across the top of the screen. Background color is
 * determined by kind. If there are multiple banners mounted at once, they will stack vertically.
 */
export function ToastBanner<I>({
    content,
    kind,
    remove,
    RenderContent,
    renderContentInput,
}: Props<I>): JSX.Element {
    const bgClass = cx({
        'bg-secondary-500': kind === 'info-banner',
        'bg-highlight-paleorange': kind === 'warning-banner',
    });

    const gridClasses = cx(bgClass, 'w-screen grid grid-rows-1');

    const contentClasses = cx(
        bgClass,
        'flex-grow flex justify-center p-6 text-white',
        {
            'font-bold': typeof content === 'string',
        },
    );

    return (
        <div
            className={gridClasses}
            style={{
                gridTemplateColumns: 'auto 30px',
            }}
        >
            {content && <div className={contentClasses}>{content}</div>}
            {RenderContent && (
                <RenderContent remove={remove} input={renderContentInput} />
            )}
            <IconX
                width={16}
                fillColor="tertiary-400"
                handleClick={remove}
                addClasses="my-4"
            />
        </div>
    );
}
